import { render } from "./Foot.vue?vue&type=template&id=a7822140&scoped=true"
import script from "./Foot.vue?vue&type=script&lang=js"
export * from "./Foot.vue?vue&type=script&lang=js"

import "./Foot.vue?vue&type=style&index=0&id=a7822140&scoped=true&lang=css"

import exportComponent from "E:\\软件项目\\神木市官网界面\\shenmu-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7822140"]])

export default __exports__